import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Guard } from '../../components/layout/Guard';

const List = lazy(() => import('./PaymentsListPage'));
const New = lazy(() => import('./PaymentNewPage'));
const Detail = lazy(() => import('./PaymentDetailPage'));

const routes: RouteObject[] = [
  { path: '/payments', element: <Guard any={['payment.read']}><List /></Guard> },
  { path: '/payments/new', element: <Guard any={['payment.create']}><New /></Guard> },
  { path: '/payments/:id', element: <Guard any={['payment.read']}><Detail /></Guard> },
];
export default routes;
